import { ptBR } from '@mui/x-date-pickers/locales'
import { deepOrange, grey } from '@mui/material/colors'
import JostTtf from '../assets/fonts/Jost-Medium.ttf'
import JostLightTtf from '../assets/fonts/Jost-Light.ttf'
import BalooBhainaTtf from '../assets/fonts/BalooBhaina-Regular.ttf'
import IntegralCFBoldTtf from '../assets/fonts/IntegralCF-Bold.otf'
/* PalleteColor variants (https:
  light, main, dark, contrastText
*/

const theme = {
  palette: {
    primary: {
      light: '#b22a00',
      main: '#FF7043',
      dark: '#ff6333',
      contrastText: '#FFF',
    },
    text: {
      primary: '#000',
      secondary: grey[800],
    },
  },
}

export const getDesignTokens = mode => ({
  ptBR,
  typography: {
    fontFamily: 'Jost, Jost-Light, BalooBhaina-Regular',
  },
  components: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [
          {
            fontFamily: 'Jost',
            fontStyle: 'normal',
            fontDisplay: 'swap',
            fontWeight: 400,
            src: `local('Jost'), local('Jost-Medium'), url(${JostTtf}) format('truetype')`,
            unicodeRange:
              'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
          },
          {
            fontFamily: 'Jost-Light',
            fontStyle: 'normal',
            fontDisplay: 'swap',
            fontWeight: 400,
            src: `local('Jost-Light'), url(${JostLightTtf}) format('truetype')`,
            unicodeRange:
              'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
          },
          {
            fontFamily: 'baloo-bhaina',
            fontStyle: 'normal',
            fontDisplay: 'swap',
            fontWeight: 400,
            src: `local('BalooBhaina-Regular'), url(${BalooBhainaTtf}) format('truetype')`,
            unicodeRange:
              'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
          },
          {
            fontFamily: 'IntegralCF-Bold',
            fontStyle: 'normal',
            fontDisplay: 'swap',
            src: `local('IntegralCF-Bold'), url(${IntegralCFBoldTtf}) format('truetype')`,
            unicodeRange:
              'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
          },
        ],
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontFamily: 'Jost',
            fontWeight: 500,
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#F5F5F5',
            '&.MuiFilledInput-underline:before': {
              borderBottom: 'none',
            },
          },
          '&.Mui-focused': {
            backgroundColor: '#F5F5F5',
          },
          '&.MuiFilledInput-underline:before': {
            borderBottom: 'none',
          },
          '&.Mui-error': {
            color: 'red',
          },
        },
      },

      MuiSvgIcon: {
        root: {
          '&:hover': {
            color: '#FF7043',
          },
        },
      },
      typography: {
        fontFamily: 'Jost',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'jost-light',
          fontWeight: 'bold',
          textTransform: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#F5F5F5',
          outline: 'none',
        },
      },
    },
  },

  palette: {
    mode,
    ...(mode === 'light'
      ? {
          primary: {
            light: '#b22a00',
            main: '#FF7043',
            dark: '#ff6333',
            contrastText: '#FFF',
            lightOrange: '#FF70434D',
          },
          secondary: {
            main: '#FAE6D8',
            lightGrey: '#F0F0F0',
            lightGreen: '#24AD494D',
            lightOrange: '#ad320e',
            lightBlue: '#4d87fa',
          },
          success: {
            main: '#4caf50',
            lightGreen: '#bde6c8',
            green: '#12C06A',
          },
          warning: {
            main: '#FFAE19',
          },
          text: {
            primary: '#000',
            secondary: grey[800],
            grey: '#7C7C7C',
          },
          gold: {
            main: '#FFAE19',
            fadedGold: '#FFEDCF',
          },
          background: {
            monthly: '#F5F5F5',
          },
          error: {
            main: '#F44336',
            light: 'rgba(240, 85, 69, 0.3)',
            dark: '#7f0000',
          },
        }
      : {
          primary: deepOrange,
          background: {
            default: '#333',
            paper: '#424242',
          },
          text: {
            primary: '#FFF',
            secondary: grey[500],
          },
        }),
    ptBR,
  },
})

export default theme
